// defines the action type
export const UPDATE_WIDTH = 'UPDATE_WIDTH';

// defines the action that dispatches the action to the store
export const updateWindowWidth = (width) => ({
    type: UPDATE_WIDTH,
    width
});